import type { ILocale } from 'src/providers/l10n/types';

export enum LocalisedLinkLevel {
    CurrentPage = 'current-page',
    ProjectHome = 'project-home',
    MainHome = 'main-home',
}

export interface ILocaleWithLink extends ILocale {
    level?: LocalisedLinkLevel;
    url?: string;
}

export interface ILocaleList {
    [localeSlug: string]: string;
}

export interface ILocaliseListSuccessfulResponse {
    [url: string]: ILocaleList;
}

export type TLocaliseListEmptyResponse = [];

export type ILocaliseListResponse = ILocaliseListSuccessfulResponse | TLocaliseListEmptyResponse;
